import React from 'react';

function ContractList() {
  return <div>ContractList</div>;
}

export default ContractList;
